import { Component } from '@angular/core';

@Component({
  selector: 'app-financial-check',
  templateUrl: './financial-check.component.html',
  styleUrl: './financial-check.component.scss'
})
export class FinancialCheckComponent {
  docsItems = [
    { title: ' فحص الهياكل المالي   ', image: 'assets/allServices/carouselsec.jpg' },

  ];
}
